import React from "react";
import "./CardContainer.css";

interface Props {
  children: React.ReactNode;
}

function CardContainer(props: Props) {
  const { children } = props;

  return <div className="card-container">{children}</div>;
}

export default CardContainer;
